import React, { Component } from "react"
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { withRouter } from 'react-router-dom';
import { isEmpty, map } from "lodash";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from 'react-moment';
import {
  Row,
  Col,
  FormGroup,
  Label
} from "reactstrap"
import { withTranslation } from "react-i18next";
import { addLeadNoteTab, getAppLeadTab, getNoteLeadTab } from "../../../store/leads/actions"
import SaveButton from "components/buttons/save";
import AiButton from "components/buttons/aiBtn";
import { API_URL } from "helpers/app_url";
import axios from "axios";
import SafeField from "helpers/SafeField";
class LeedMessage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      leadMessages: [],

    }
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleSubmit = (value, { resetForm }) => {
    const payload = {
      messageFromId: parseInt(value.messageFromId),
      messageToId: parseInt(value.messageToId),
      messageFrom: value.messageFrom,
      messageTo: value.messageTo,
      messageText: value.messageText,
      agentId: parseInt(value.agentId),
      isActive: true,
    }
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const url = `${API_URL}ContactMessage`;
    toast.loading("Please wait...");
    axios
      .post(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.success) {
          toast.dismiss();
          toast.success("Saved successfully");
          resetForm();
          this.fetchLeadMessage();
        } else {
          toast.dismiss();
          toast.error('some issue while sending message');
          console.warn("Submission failed:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error sending message:", error);

      });
  }
  componentDidMount() {
    const { match: { params } } = this.props;

    this.fetchLeadMessage();
  }
  fetchLeadMessage() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      ContactId: this.props.match.params.id,
      agentId : localStorage.getItem('userId')
    };
    axios
      .get(`${API_URL}ContactMessage/allContact`, { headers, params })
      .then((response) => {
        this.setState({ leadMessages: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  handleInsertAi = (generatedText, setFieldValue) => {
    //
    setFieldValue("messageText", generatedText);
  };
  render() {
    const { leadMessages } = this.state;
    return (
      <React.Fragment>
        {/* <ToastContainer autoClose={2000} /> */}
        <div className="h4 card-title">Create Message *</div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            messageFromId: localStorage.getItem("userId"),
            messageToId: this.props.match.params.id,
            messageFrom: 'Realtor',
            messageTo: 'contact',
            messageText: '',
            agentId: localStorage.getItem("userId"),
            isActive: true,


          }}
          validationSchema={Yup.object().shape({
            messageText: Yup.string().max(500, 'This filed contains only 500 characters only').required("This is Required")
          })}

          onSubmit={this.handleSubmit}
        >
          {({ errors, touched, values, handleChange, setFieldValue }) => (
            <Form
              className="needs-validation"
            >

              <Row>
                <Col md="12">
                  <FormGroup className="mb-3">
                    <Label htmlFor="addNote" className="w-100">
                      <span className="float-end"> <AiButton onInsert={(text) => this.handleInsertAi(text, setFieldValue)} /> </span>
                    </Label>
                    <SafeField
                      name="messageText"
                      onChange={handleChange}

                      as="textarea"
                      className={
                        "form-control" +
                        (errors.messageText && touched.messageText
                          ? " is-invalid"
                          : "")
                      }
                      id="messageText"
                    />
                    <ErrorMessage
                      name="messageText"
                      component="div"
                      className="invalid-feedback"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <div className="clearfix"><SaveButton>Save</SaveButton></div>


            </Form>
          )}
        </Formik>
        {leadMessages && leadMessages.length > 0 ? (
          <>
            <div className="mb-5 h4 card-title mt-20">Message History</div>
            <ul className="verti-timeline list-unstyled">

              {map(leadMessages, (noteLog, notekey) => (

                <li className="event-list eventlist" key={"_note_" + notekey}>
                  <div className="event-timeline-dot">
                    <i className="bx bx-right-arrow-circle font-size-18" />
                  </div>
                  <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                      <h5 className="font-size-14">
                        <Moment format="D MMM YY">{noteLog.createdDate}</Moment>


                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <h5 className="font-size-14"></h5>
                    </div>
                  </div>
                  <div className="exNote">{noteLog.messageText}</div>
                </li>
              ))}

            </ul>
          </>
        ) : null}
      </React.Fragment>
    )
  }
}
LeedMessage.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,


}

const mapStateToProps = ({ leads }) => (
  {


  })
const mapDispatchToProps = dispatch => ({

});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LeedMessage)))
